// Ce fichier n'est plus utilisé depuis PDL-655
import { Injectable } from '@angular/core';

@Injectable()
export class PointInspectionEffects {
}
